import { useEffect } from "react";
import { FieldActions } from "@thecb/components";

const useClearFieldOnUnmount = (fieldActions: FieldActions): void => {
  useEffect(() => {
    return () => {
      fieldActions.set && fieldActions.set("");
    };
  }, [fieldActions]);
};

export default useClearFieldOnUnmount;
